import { grey500, darkBlack, white, grey300 } from 'material-ui/styles/colors';
import { fade } from 'material-ui/utils/colorManipulator';
import Spacing from 'material-ui/styles/spacing';
import zIndex from 'material-ui/styles/zIndex';

export default {
	spacing: Spacing,
	zIndex: zIndex,
	fontFamily: 'Noto, sans-serif',
	palette: {
		/*
		primary1Color: '#26A69A',
		primary2Color: '#26A69A',
		primary3Color: '#26A69A',*/
		primary1Color: '#47A1AB',
		primary2Color: '#47A1AB',
		primary3Color: '#47A1AB',
		accent1Color: '#043471',
		accent2Color: '#043471',
		accent3Color: grey500,
		textColor: darkBlack,
		alternateTextColor: darkBlack,
		canvasColor: white,
		borderColor: grey300,
		disabledColor: fade(darkBlack, 0.3),
		pickerHeaderColor: '#154C95'
	}
};



// WEBPACK FOOTER //
// ./src/components/framework/MaterialUI/AcquireWebTheme.js